import { Clock, WebGLRenderer } from 'three';
import ThreeScene from 'home/ThreeScene';

export default class ThreeSetup {

    constructor(width, height, pixelRatio) {

        this.width = width;
        this.height = height;

        this.renderer = null;
        this.clock = null;

        this.pixelRatio = pixelRatio;

        this.threeScene = null;

    }

    init(canvas, inputCanvas) {

        this.clock = new Clock();

        this.canvas = canvas;
        this.inputCanvas = inputCanvas;

        this.renderer = new WebGLRenderer({
            alpha: true,
            canvas: this.canvas,
            // preserveDrawingBuffer: true,
        });

        this.renderer.gammaInput = false;
        this.renderer.gammaOutput = false;
        this.renderer.antialias = false;
        this.renderer.physicallyCorrectLights = false;

        this.renderer.setPixelRatio(this.pixelRatio);
        this.renderer.setSize(this.width, this.height, false);
        this.renderer.setClearColor(0x000000, 0);

        this.threeScene = new ThreeScene(this.width, this.height);
        this.threeScene.init(this.inputCanvas);

    }

    animate() {

        this.render();

    }

    render() {

        const time = this.clock.getElapsedTime();

        this.threeScene.animate(time);

        this.renderer.render(this.threeScene.scene, this.threeScene.camera);

    }

    onWindowResize(width, height) {

        this.width = width;
        this.height = height;

        this.threeScene.onWindowResize(this.width, this.height);

        this.renderer.setSize(this.width, this.height, false);

    }

    onMouseMove(mouseX, mouseY) {

        this.mouseX = mouseX;
        this.mouseY = mouseY;

        this.threeScene.onMouseMove(this.mouseX, this.mouseY);

    }

    smoothMove(moveX, moveY) {

        this.moveX = moveX;
        this.moveY = moveY;

        this.threeScene.smoothMove(this.moveX, this.moveY);

    }
}
